export const EVENT = {
  INIT_TARGETING: 'INIT_TARGETING',
  INIT_PROMO: 'INIT_PROMO',
  INIT_REVIEW: 'INIT_REVIEW',
  INIT_MESSAGE: 'INIT_MESSAGE',
  INIT_CONFIRMATION: 'INIT_CONFIRMATION',
  // Organic
  DEFAULT: 'DEFAULT',
  CLICK_BACK: 'CLICK_BACK',
  INIT_FILTER: 'INIT_FILTER',
  COMPLETE_FILTER: 'COMPLETE_FILTER',

  // CRM_HOMEPAGE
  CLICK_FILTER: 'CLICK_FILTER',
  CLICK_CUSTOMER_METRICS_ARROW: 'CLICK_CUSTOMER_METRICS_ARROW',
  CLICK_CUSTOMER_METRICS_TOOLTIP: 'CLICK_CUSTOMER_METRICS_TOOLTIP',
  CLICK_CUSTOMER_METRICS_CARD: 'CLICK_CUSTOMER_METRICS_CARD',
  CLICK_CUSTOMER_SEGMENTS_TOOLTIP: 'CLICK_CUSTOMER_SEGMENTS_TOOLTIP',
  CLICK_CUSTOMER_SEGMENTS_CHART: 'CLICK_CUSTOMER_SEGMENTS_CHART',
  CLICK_ENGAGEMENT_CAMPAIGN_ARROW: 'CLICK_ENGAGEMENT_CAMPAIGN_ARROW',
  CLICK_CREATE_CAMPAIGN: 'CLICK_CREATE_CAMPAIGN',
  CLICK_VIEW_BALANCE: 'CLICK_VIEW_BALANCE',
  CLICK_SCHEDULED_CAMPAIGN: 'CLICK_SCHEDULED_CAMPAIGN',
  VIEW_SEGMENT_DRILLDOWN_NUDGE: 'VIEW_SEGMENT_DRILLDOWN_NUDGE',
  CLICK_SEGMENT_DRILLDOWN_NUDGE: 'CLICK_SEGMENT_DRILLDOWN_NUDGE',
  VIEW_SEGMENT_DRILLDOWN_LINE_CHART: 'VIEW_SEGMENT_DRILLDOWN_LINE_CHART',
  CLICK_SEGMENT_DRILLDOWN_LINE_CHART: 'CLICK_SEGMENT_DRILLDOWN_LINE_CHART',
  VIEW_SEGMENT_DRILLDOWN_METRIC_CARD: 'VIEW_SEGMENT_DRILLDOWN_METRIC_CARD',
  CLICK_SEGMENT_DRILLDOWN_METRIC_CARDS: 'CLICK_SEGMENT_DRILLDOWN_METRIC_CARDS',
  CLICK_SEE_METRIC_DETAILS: 'CLICK_SEE_METRIC_DETAILS',

  // CRM_METRIC_INSIGHT
  VIEW_LINE_CHART: 'VIEW_LINE_CHART',
  CLICK_LINE_CHART: 'CLICK_LINE_CHART',
  CLICK_LINE_CHART_TOOLTIP: 'CLICK_LINE_CHART_TOOLTIP',
  CLICK_DOWNLOAD: 'CLICK_DOWNLOAD',

  // CRM_LISTING_PAGE
  CLICK_CAMPAIGN: 'CLICK_CAMPAIGN',
  CLICK_VIEW_ALL: 'CLICK_VIEW_ALL',
  CLICK_BALANCE_ICON: 'CLICK_BALANCE_ICON',
  CLICK_MESSAGE_BALANCE: 'CLICK_MESSAGE_BALANCE',
  CLICK_TOP_UP: 'CLICK_TOP_UP',
  INIT_TOPUP: 'INIT_TOPUP',
  COMPLETE_TOPUP: 'COMPLETE_TOPUP',
  VIEW_NUDGE: 'VIEW_NUDGE',
  CLICK_NUDGE: 'CLICK_NUDGE',

  // CHOPE_MANAGE_CAMPAIGNS
  CLICK_TOGGLE_CAMPAIGN: 'CLICK_TOGGLE_CAMPAIGN',

  // CRM_CAMPAIGN_VIEW
  CLICK_CANCEL_CAMPAIGN: 'CLICK_CANCEL_CAMPAIGN',
  CLICK_RECREATE_CAMPAIGN: 'CLICK_RECREATE_CAMPAIGN',
  COMPLETE_TARGETING: 'COMPLETE_TARGETING',
  COMPLETE_MESSAGE: 'COMPLETE_MESSAGE',
  COMPLETE_REVIEW: 'COMPLETE_REVIEW',
  COMPLETE_CONFIRMATION: 'COMPLETE_CONFIRMATION',
  COMPLETE_PROMO: 'COMPLETE_PROMO',

  // CRM_CAMPAIGN_PERFORMANCE_REPORT
  SWITCH_TAB: 'SWITCH_TAB',
  VIEW_METRIC: 'VIEW_METRIC',
  CLICK_TOOLTIP: 'CLICK_TOOLTIP',
  CLICK_TIME_SLOT: 'CLICK_TIME_SLOT',
  EXPAND_MESSAGE_BALANCE: 'EXPAND_MESSAGE_BALANCE',
  VIEW_REACH_SECTION: 'VIEW_REACH_SECTION',
  VIEW_CONVERSION_SECTION: 'VIEW_CONVERSION_SECTION',
  CLICK_CONVERSION_CHART: 'CLICK_CONVERSION_CHART',
  VIEW_INSIGHT: 'VIEW_INSIGHT',
  CLICK_INSIGHT: 'CLICK_INSIGHT',
  VIEW_POPOVER: 'VIEW_POPOVER',
  CLICK_POPOVER: 'CLICK_POPOVER',
  CLICK_CLOSE_POPOVER: 'CLICK_CLOSE_POPOVER',

  // Chope CRM (legacy / granular)
  CHOPE_CLICK_CREATE: 'CHOPE_CLICK_CREATE',
  CHOPE_CLICK_SETUP: 'CHOPE_CLICK_SETUP',
  CHOPE_COMPLETE_AUDIENCE: 'CHOPE_COMPLETE_AUDIENCE',
  CHOPE_COMPLETE_MESSAGE: 'CHOPE_COMPLETE_MESSAGE',
  CHOPE_COMPLETE_REVIEW: 'CHOPE_COMPLETE_REVIEW',

  /** Chope create flow — shared event names with Grab create; disambiguate via `state` facet (CRM_CREATE_CAMPAIGN_CHOPE). */
  EDIT: 'EDIT',
  INIT_MESSAGE_DETAIL: 'INIT_MESSAGE_DETAIL',
  COMPLETE_MESSAGE_DETAIL: 'COMPLETE_MESSAGE_DETAIL',
} as const;

export const stateName = {
  CRM_CREATE_CAMPAIGN: 'CRM_CREATE_CAMPAIGN',
  /** Chope one-time / automated campaign creation (sheet: CRM_CREATE_CAMPAIGN_CHOPE). */
  CRM_CREATE_CAMPAIGN_CHOPE: 'CRM_CREATE_CAMPAIGN_CHOPE',
  CRM_HOMEPAGE: 'CRM_HOMEPAGE',
  CRM_METRIC_INSIGHT: 'CRM_METRIC_INSIGHT',
  MANAGE_CRM_CAMPAIGN: 'MANAGE_CRM_CAMPAIGN',
  MANAGE_CRM_CAMPAIGN_DETAIL: 'MANAGE_CRM_CAMPAIGN_DETAIL',
  CRM_MESSAGE_BALANCE: 'CRM_MESSAGE_BALANCE',
  CRM_CAMPAIGN_REPORT: 'CRM_CAMPAIGN_REPORT',
  CHOPE_MANAGE_CAMPAIGNS: 'CHOPE_MANAGE_CAMPAIGNS',
  CHOPE_CREATE_CAMPAIGN: 'CHOPE_CREATE_CAMPAIGN',
} as const;

export const pathStateNameMap: Record<string, (typeof stateName)[keyof typeof stateName]> = {
  '/': stateName.CRM_HOMEPAGE,
  '/metrics': stateName.CRM_METRIC_INSIGHT,
  '/balance': stateName.CRM_MESSAGE_BALANCE,
  '/campaign/list': stateName.MANAGE_CRM_CAMPAIGN,
  '/campaign/:id': stateName.MANAGE_CRM_CAMPAIGN_DETAIL,
  '/chope/campaign/list': stateName.CHOPE_MANAGE_CAMPAIGNS,
  '/chope/campaign/create': stateName.CHOPE_CREATE_CAMPAIGN,
};

export const CampaignTab = {
  PERFORMANCE: 'performance',
  CAMPAIGN_DETAIL: 'campaign_detail',
} as const;

export const ExitDestination = {
  CAMPAIGN_LIST: 'campaign_list',
  MESSAGE_BALANCE: 'home',
} as const;

export const CampaignCRMType = {
  CHOPE: 'chope',
  GRAB: 'grab',
} as const;

export const GrabCampaignScheduleType = {
  ONE_TIME: 'One-time',
  RECURRING: 'Recurring',
} as const;

export const GrabCampaignSection = {
  RECURRING_CAMPAIGNS: 'Recurring campaigns',
  ONE_TIME_CAMPAIGNS: 'One-time campaigns',
  CAMPAIGN_LIST: 'Campaign List',
  SCHEDULED: 'Scheduled',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  EMPTY: '',
} as const;

export const GrabCampaignListTab = {
  RECURRING: 'recurring',
  ONE_TIME: 'one-time',
} as const;

export const PerformanceMetricName = {
  PROMO_SPEND: 'promo_spend',
  ASSISTED_ORDERS: 'assisted_orders',
  ASSISTED_SALES: 'assisted_sales',
  MESSAGE_BALANCE: 'message_balance_usage',
  BOOKINGS: 'bookings',
  COVERS: 'covers',
  MESSAGE: 'message',
} as const;

export const CampaignStatusSection = {
  SCHEDULED: 'SCHEDULED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
} as const;

export const ChopeCampaignSection = {
  ONE_TIME_CAMPAIGNS: 'One-time campaigns',
  AUTOMATED_CAMPAIGNS: 'Automated campaigns',
} as const;

/** `EDIT` facet `MODULE` strings - Grab create (`CRM_CREATE_CAMPAIGN`). Align with tracking spec. */
export const GRAB_CREATE_EDIT_MODULES = {
  SET_AUDIENCE_CAMPAIGN_NAME: 'SET_AUDIENCE_CAMPAIGN_NAME',
  SET_AUDIENCE_TARGET_AUDIENCE: 'SET_AUDIENCE_TARGET_AUDIENCE',
  SET_AUDIENCE_LIMIT_TYPE: 'SET_AUDIENCE_LIMIT_TYPE',
  SET_AUDIENCE_LIMIT: 'SET_AUDIENCE_LIMIT',
  SET_MESSAGE_DATE: 'SET_MESSAGE_DATE',
  SET_MESSAGE_TIME: 'SET_MESSAGE_TIME',
  SET_CHANNEL: 'SET_CHANNEL',
  SET_SCHEDULE_TYPE: 'SET_SCHEDULE_TYPE',
  SET_FREQUENCY: 'SET_FREQUENCY',
  SET_PROMO_TYPE: 'SET_PROMO_TYPE',
  SET_DISCOUNT_TYPE: 'SET_DISCOUNT_TYPE',
  SET_DISCOUNT_VALUE: 'SET_DISCOUNT_VALUE',
  SET_MINIMUM_ORDER: 'SET_MINIMUM_ORDER',
  SET_MAXIMUM_DISCOUNT_AMOUNT: 'SET_MAXIMUM_DISCOUNT_AMOUNT',
  SET_PROMO_EXPIRY_DATE: 'SET_PROMO_EXPIRY_DATE',
  SET_PROMO_EXPIRY_TIME: 'SET_PROMO_EXPIRY_TIME',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  SET_MESSAGE: 'SET_MESSAGE',
  SET_SUBJECT: 'SET_SUBJECT',
  CLICK_IMPROVE_BUTTON: 'CLICK_IMPROVE_BUTTON',
  UPLOAD_EMAIL_IMAGE: 'UPLOAD_EMAIL_IMAGE',
  SET_HEADLINE: 'SET_HEADLINE',
  SET_BODY: 'SET_BODY',
  SET_IMAGES: 'SET_IMAGES',
  SET_FOOTER_ADDRESS: 'SET_FOOTER_ADDRESS',
  SET_FOOTER_PHONE: 'SET_FOOTER_PHONE',
  SET_FOOTER_INSTAGRAM: 'SET_FOOTER_INSTAGRAM',
  SET_FOOTER_FACEBOOK: 'SET_FOOTER_FACEBOOK',
  SET_FOOTER_TIKTOK: 'SET_FOOTER_TIKTOK',
  CLICK_REWRITE_MESSAGE: 'CLICK_REWRITE_MESSAGE',
  SET_BUTTON_LABEL: 'SET_BUTTON_LABEL',
  SET_BUTTON_LINK: 'SET_BUTTON_LINK',
  SET_BUTTON_ADD: 'SET_BUTTON_ADD',
  SET_BUTTON_REMOVE: 'SET_BUTTON_REMOVE',
  NEXT: 'NEXT',
} as const;

/** `EDIT` facet `MODULE` strings - Grab review-card edit buttons. */
export const GRAB_REVIEW_EDIT_MODULES = {
  EDIT_TARGET_AND_REACH: 'EDIT TARGET AND REACH',
  EDIT_CHANNEL_AND_SCHEDULE: 'EDIT CHANNEL AND SCHEDULE',
  EDIT_PROMOTION: 'EDIT PROMOTION',
  EDIT_MESSAGE: 'EDIT MESSAGE',
} as const;

/** `EDIT` facet `MODULE` strings — Chope create (`CRM_CREATE_CAMPAIGN_CHOPE`). Align with tracking spec. */
export const CHOPE_CREATE_EDIT_MODULES = {
  // Audience
  SET_AUDIENCE_CAMPAIGN_NAME: 'SET AUDIENCE CAMPAIGN NAME',
  SET_AUDIENCE_TARGET_AUDIENCE: 'SET AUDIENCE TARGET AUDIENCE',
  SET_AUDIENCE_CRITERIA: 'SET AUDIENCE CRITERIA',
  SET_AUDIENCE_EXCLUSIONS: 'SET AUDIENCE EXCLUSIONS',
  // Setup message (oneTime)
  SET_MESSAGE_CHANNEL: 'SET MESSAGE CHANNEL',
  SET_MESSAGE_DATE: 'SET MESSAGE DATE',
  SET_MESSAGE_TIME: 'SET MESSAGE TIME',
  // Create message — WhatsApp
  UPLOAD_IMAGE: 'UPLOAD IMAGE',
  SET_MESSAGE: 'SET MESSAGE',
  // Create message — Email
  SET_SUBJECT: 'SET SUBJECT',
  CLICK_IMPROVE_BUTTON: 'CLICK IMPROVE BUTTON',
  UPLOAD_EMAIL_IMAGE: 'UPLOAD EMAIL IMAGE',
  SET_HEADLINE: 'SET HEADLINE',
  SET_BODY: 'SET BODY',
  SET_IMAGES: 'SET IMAGES',
  SET_FOOTER_ADDRESS: 'SET FOOTER ADDRESS',
  SET_FOOTER_PHONE: 'SET FOOTER PHONE',
  SET_FOOTER_INSTAGRAM: 'SET FOOTER INSTAGRAM',
  SET_FOOTER_FACEBOOK: 'SET FOOTER FACEBOOK',
  SET_FOOTER_TIKTOK: 'SET FOOTER TIKTOK',
  CLICK_REWRITE_MESSAGE: 'CLICK REWRITE MESSAGE',
  // Shared (WhatsApp + Email)
  SET_BUTTON_LABEL: 'SET BUTTON LABEL',
  SET_BUTTON_LINK: 'SET BUTTON LINK',
  SET_BUTTON_ADD: 'SET BUTTON ADD',
  SET_BUTTON_REMOVE: 'SET BUTTON REMOVE',
  NEXT: 'NEXT',
  // Automated criteria
  SET_AUTOMATED_TOTAL_VISITS: 'SET AUTOMATED TOTAL VISITS',
  SET_AUTOMATED_BOOKING_STATUS: 'SET AUTOMATED BOOKING STATUS',
  SET_AUTOMATED_LAST_VISIT_MONTHS: 'SET AUTOMATED LAST VISIT MONTHS',
  CLICK_EDIT_CRITERIA: 'CLICK EDIT CRITERIA',
  CLICK_SAVE_CRITERIA: 'CLICK SAVE CRITERIA',
  CLICK_CANCEL_CRITERIA: 'CLICK CANCEL CRITERIA',
} as const;
